import {Component, OnInit} from '@angular/core';

@Component({
    selector: 'app-conditions',
    templateUrl: './conditions.component.html',
    styleUrls: ['./conditions.component.css'],
    standalone: false
})
export class ConditionsComponent implements OnInit {

  constructor() {
  }

  ngOnInit() {
  }

}
